<template>
  <div
    id="app"
    class="app">
    <iframe
      id="panoptoLogout"
      style="width:0px; height:0px; border:0px; border:none; visibility:hidden; display:none" />
    <link
      :href="basePath + '/css/common.css?ver=v20210607'"
      rel="stylesheet"
      type="text/css">
    <link
      :href="basePath + '/css/content.css?ver=v20210607'"
      rel="stylesheet"
      type="text/css">
    <router-view />
  </div>
</template>
<script>
import WepLoading from '~pages/contents/loading/WepLoading.vue'
import moment from 'moment'

export default {
  name: 'App',
  components: {
    'wep-loading': WepLoading
  },
  mixins: [],
  data () {
    return {
      basePath: this.getStore('mmpAuth').state.basePath,
      wepNm: this.getStore('mmpAuth').state.wepSets.wepNm
    }
  },
  created () {
    // App Title
    if (this.$t('TEMPLT001') === 'TEMPLT001') {
      document.title = this.wepNm
    } else {
      document.title = this.$t('TEMPLT001')
    }
  },
  mounted () {
    let nowTime = moment(new Date()).format('YYYYMMDDHHmm')
    // 공통 프로모션 CSS 로드
    const webinarCss = document.createElement('link')
    webinarCss.rel = 'stylesheet'
    webinarCss.href = 'https://static.multicampus.com/de_common/webinar/assets/css/webinar.css?version=' + nowTime
    document.head.appendChild(webinarCss)

    // 공통 프로모션 스크립트 로드
    const WebinarScript = document.createElement('script')
    WebinarScript.src = 'http://static.multicampus.com/de_common/webinar/assets/js/webinar.js?version=' + nowTime
    WebinarScript.async = true
    document.head.appendChild(WebinarScript)
  },
  methods: {
  },
  store: window.vue.getStore('root')
}
</script>



// WEBPACK FOOTER //
// src/App/App.vue